var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembersHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 14.5513C15.286 14.5514 17.326 15.2073 18.5493 16.2095C19.7918 17.2276 20.1206 18.5428 20.1206 19.6705V20.1207H3.87939V19.6705C3.87941 18.6028 4.21113 17.2927 5.44775 16.2613C6.66958 15.2423 8.70937 14.5513 12.0005 14.5513Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.9336,
    cy: 7.93132,
    r: 3.3848,
    stroke: "#F4F4F9",
    strokeWidth: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.009,
    height: 18.009,
    fill: "white",
    transform: "translate(2.99561 2.99548)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersHub);
export default __webpack_public_path__ + "static/media/MembersHub.ea070ea9a08d0b9e13bac3b146382926.svg";
export { ForwardRef as ReactComponent };